import _ from 'lodash'

export const categoryMixins = {
  computed: {
    sortedCategories() {
      return _.sortBy(this.categories, (c) => c.position)
    },
  },
}
